import { updateIntl } from 'react-intl-redux';
import moment from 'moment';

import {loadJson} from '../utils/loadjson';
const viMessage = loadJson( '/assets/vi.json');
const enMessage = loadJson( '/assets/en.json');

function switchLanguage(locale) {
  return function (dispatch) {
    const momentLocale = (locale === 'vi' ?  'vi' : 'en' ) ;
    moment.locale(momentLocale);
    const messages = (locale === 'vi' ? viMessage : enMessage ) ;
    dispatch(updateIntl({
      locale,
      messages,
    }));
  };
}

export {
  switchLanguage,
};



// WEBPACK FOOTER //
// ./src/actions/intl.js